/**
 * Terms of Use – Conditions for using the NAC Stock Management System
 */
import React from 'react';
import { Typography, Card } from 'antd';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import PublicPageLayout from '../components/PublicPageLayout';
import './TermsOfUse.css';

const { Title, Paragraph } = Typography;

const TermsOfUse: React.FC = () => {
  return (
    <PublicPageLayout>
      <Helmet>
        <title>Terms of Use – NAC Software and Tech Solutions</title>
        <meta name="description" content="Terms of use for the Bhutan NAC Stock Management System. Conditions for using our stock management and POS software." />
      </Helmet>
      <div className="terms-content">
        <Link to="/" className="terms-back">← Back to Home</Link>
        <Title level={2}>Terms of Use</Title>
        <Paragraph type="secondary">Last updated: {new Date().toLocaleDateString()}</Paragraph>

        <Card className="terms-card">
            <Title level={4}>1. Acceptance of Terms</Title>
            <Paragraph>
              By accessing or using the NAC Software and Tech Solutions Stock Management System (the &quot;System&quot;), you agree to be bound by these Terms of Use. If you do not agree, do not use the System.
            </Paragraph>

            <Title level={4}>2. Use of the System</Title>
            <Paragraph>
              You agree to use the System only for lawful business purposes. You must use the correct portal (Admin or User) for your role. You are responsible for maintaining the confidentiality of your login credentials and for all activities under your account.
            </Paragraph>

            <Title level={4}>3. Acceptable Use</Title>
            <Paragraph>
              You shall not: (a) share your credentials with others; (b) attempt to access areas of the System for which you are not authorized; (c) use the System for unauthorized purposes; (d) interfere with the System&apos;s operation or security; (e) share sensitive company data outside the System without authorization.
            </Paragraph>

            <Title level={4}>4. Data and Privacy</Title>
            <Paragraph>
              You retain ownership of your data. We process data in accordance with our privacy practices and to provide the service. You are responsible for ensuring your use complies with applicable data protection laws.
            </Paragraph>

            <Title level={4}>5. Support and Availability</Title>
            <Paragraph>
              We strive to maintain system availability but do not guarantee uninterrupted access. Contact us for technical support. Scheduled maintenance may result in temporary unavailability.
            </Paragraph>

            <Title level={4}>6. Changes</Title>
            <Paragraph>
              We may update these Terms from time to time. Continued use of the System after changes constitutes acceptance. We will notify you of material changes via email or in-app notice.
            </Paragraph>

            <Title level={4}>7. Contact</Title>
            <Paragraph>
              For questions about these Terms, contact us at{' '}
              <a href="mailto:nacsoftwareandtechsolutions26@gmail.com">nacsoftwareandtechsolutions26@gmail.com</a>.
            </Paragraph>
          </Card>
      </div>
    </PublicPageLayout>
  );
};

export default TermsOfUse;
